var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 392.4 34.1",
    style: {
      enableBackground: "new 0 0 392.4 34.1"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#47B75A;}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000026876035199311565820000016053996531790730419_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.1935,
    y1: -8.2635,
    x2: 54.3685,
    y2: 35.9115,
    gradientTransform: "matrix(1 0 0 -1 0 36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C492B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#336B34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#367539"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#3D9247"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#43A652"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#46B358"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#47B75A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,34.1c-1.3-3.9-3.4-14,6.3-25.1c0,0-27.1,1.9-40.7,25.1H0C6.5,6.9,54.3,0,54.3,0 c-16.8,18.1-7.7,34.1-7.7,34.1H34.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53,15.6h13.9c3.5,0,4.4,0.1,5.5,0.7c1.8,0.9,2.4,2.6,2.4,6s-0.8,5.3-2.3,6.2c-1.1,0.7-2.3,0.9-5.5,0.9h-8.9 L58.1,34h-5.5L53,15.6z M66.3,25c2.3,0,2.9-0.5,3-2.2c0.1-2.2-0.5-2.7-2.8-2.7h-8.1L58.3,25H66.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.8,15.6c2.8,0.5,4.1,2,4.4,4.9c0.1,1.5,0.1,3,0.1,4.5c-0.1,4.4-0.6,6.2-2.2,7.5c-1.1,0.9-2.7,1.4-5.3,1.5 c-1,0.1-3.4,0.1-5.2,0.1c-2.6,0.1-5.1,0-7.6-0.3c-2-0.3-3.2-1.1-3.8-2.5s-0.8-2.7-0.7-6.7c-0.1-1.7,0.1-3.4,0.5-5.1 c0.5-1.8,1.9-3.2,3.7-3.5c1.5-0.4,3.2-0.6,8-0.6C93.4,15.3,96.2,15.4,98.8,15.6z M85.2,20.5c-0.8,0.6-1,1.5-1.1,4.1 s0.1,3.7,0.8,4.3s1.6,0.7,5.8,0.7c4.8,0,5.8-0.2,6.4-1.1c0.5-0.7,0.7-1.6,0.8-4c0.1-4.6,0-4.7-6.8-4.7C87,19.9,85.9,20,85.2,20.5z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.9,15.6h5.5l-0.2,6.8h2.9l7.7-6.9h7.6l-10.7,9.1l11.2,9.2h-8l-8-7h-2.8l-0.2,7h-5.5L107.9,15.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.9,15.5l-0.1,4.2h-14.7l-0.1,3.2h13.9l-0.1,3.6h-13.9l-0.1,3.2h14.9l-0.1,4.1h-20.3l0.4-18.3L155.9,15.5z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,15.5h15.7c3.2,0,4.6,0.3,5.6,1.1c1,0.9,1.5,2.4,1.4,4.9c-0.1,3.4-0.9,4.8-3.3,5.3 c2.3,0.4,2.9,1.3,2.8,4.1l-0.1,2.9h-5.6l0.1-2.3c0-2-0.5-2.4-3-2.3h-8.5l-0.1,4.6h-5.5L160.1,15.5z M174.1,24.7 c2.7,0,3.2-0.3,3.2-2.1c0-1.2-0.1-1.7-0.4-2.1s-0.9-0.5-2.5-0.5h-8.8l-0.1,4.7H174.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.3,27c-0.1,2.7-0.2,3.6-0.6,4.4c-0.8,1.6-2.2,2.3-5.1,2.5c-1.1,0.1-3.3,0.1-7,0.1c-5.2,0-6.9-0.2-8.4-1.2 c-1.8-1.1-2.2-3.1-2.1-8.5c0.1-4.8,0.7-6.6,2.7-7.7c1.7-1,3.4-1.2,8.5-1.2c6.8,0,8.3,0.1,9.8,0.9s2.1,2.4,2,5V22h-5.3 c-0.1-2-0.5-2.2-5.3-2.2c-4.6,0-5.4,0.1-6.1,0.7s-0.8,1.4-0.9,4.3c-0.1,4.4,0.3,4.7,5.6,4.7c4.1,0,4.7,0,5.5-0.4s1.1-0.9,1.2-2.2 L212.3,27z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M236.8,15.7c2.8,0.5,4.1,2,4.4,4.9c0.1,1.5,0.1,3,0.1,4.4c-0.1,4.4-0.6,6.2-2.2,7.5c-1.1,0.9-2.7,1.4-5.3,1.5 c-1,0.1-3.4,0.1-5.2,0.1c-2.6,0.1-5.1,0-7.7-0.3c-2-0.3-3.2-1.1-3.8-2.5s-0.8-2.7-0.7-6.7c-0.1-1.7,0.1-3.4,0.5-5.1 c0.4-1.8,1.9-3.2,3.7-3.6c1.5-0.4,3.2-0.6,8-0.6C233.9,15.4,235.5,15.4,236.8,15.7z M223,20.5c-0.8,0.6-1,1.5-1.1,4.1 s0.1,3.7,0.8,4.3s1.6,0.7,5.8,0.7c4.8,0,5.8-0.2,6.4-1c0.5-0.7,0.7-1.6,0.8-4c0.1-4.6,0-4.7-6.8-4.7C224.9,19.9,223.8,20,223,20.5 z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.8,15.6h7.4l9.5,18.3h-6.1l-1.7-3.3h-11.8l-1.8,3.3H243L253.8,15.6z M261.1,26.8l-3.8-7.3l-4.1,7.3H261.1 z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.1,27c-0.1,2.7-0.2,3.6-0.6,4.4c-0.8,1.6-2.3,2.3-5.1,2.5c-1.1,0.1-3.3,0.1-7,0.1c-5.3,0-7-0.2-8.4-1.2 c-1.8-1.2-2.2-3.1-2.1-8.5c0.1-4.8,0.7-6.6,2.7-7.7c1.7-1,3.4-1.2,8.5-1.2c6.8,0,8.3,0.1,9.8,0.9s2.1,2.4,2,5.1V22h-5.3 c0-2-0.5-2.2-5.3-2.2c-4.5,0-5.4,0.1-6.1,0.7s-0.8,1.3-0.9,4.3c-0.1,4.4,0.3,4.7,5.6,4.7c4.1,0,4.7,0,5.5-0.4s1.1-0.9,1.1-2.2 H296.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.7,15.6h5.6l-0.2,6.8h12.6l0.2-6.8h5.5L324,33.9h-5.6l0.2-7h-12.7l-0.2,7h-5.6L300.7,15.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329.2,15.6h5.6l-0.5,18.3h-5.6L329.2,15.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M339.5,15.6h8.8L359,29.5l0.2-13.9h5.2L364,33.9h-8.9l-10.5-13.8l-0.2,13.8H339L339.5,15.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M387,21.8c0-1.4-0.6-2-2.2-2h-1.4h-2h-2c-2.7,0-2.7,0-3.3,0.2c-0.9,0.2-1.6,1-1.6,1.9 c-0.1,0.5-0.2,2.2-0.2,3.4c-0.1,2.5,0.1,3.5,0.9,4c0.9,0.5,1.8,0.7,2.8,0.6c0.6,0,0.6,0,4,0c3.6,0,4.3-0.2,4.8-1.4 c0.1-0.3,0.1-0.7,0.1-1V27h-7l0.1-3.4h12.5l-0.1,2.5c-0.1,3-0.2,4.1-0.6,5.1c-0.7,1.7-2,2.5-4.3,2.8c-0.6,0-2.2,0.1-7.6,0.1 c-2.3,0.1-4.6,0-6.9-0.3c-2-0.4-3.1-1.3-3.7-2.8c-0.5-1.2-0.6-2.5-0.5-5.9c0.1-3.9,0.4-5.5,1.1-6.8s2.2-2.2,4.5-2.5 c2.3-0.2,4.6-0.3,7-0.2c5,0,6.6,0.1,7.7,0.4c2.8,0.7,3.7,2.1,3.5,6L387,21.8z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.c1f8c1ab.svg";